/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import PropTypes from 'prop-types';
import './dataGrid.scss';
import { Checkbox, IconButton } from '@mui/material';
import UnfoldMoreSharpIcon from '@mui/icons-material/UnfoldMoreSharp';
import KeyboardArrowDownSharpIcon from '@mui/icons-material/KeyboardArrowDownSharp';
import KeyboardArrowUpSharpIcon from '@mui/icons-material/KeyboardArrowUpSharp';
import MoreIcon from '../../Assets/images/svg/dar_dot_menu.svg';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MagnifyingGlass from '../../Assets/images/svg/dar_magnifying.svg';
import { ClickAwayListener } from '@mui/base/ClickAwayListener';
import Tooltip from '@mui/material/Tooltip';
import FilterAltIcon from '../../Assets/images/svg/dar_filter_black.svg';
import PaginationButtons from './pagination';
import ClearIcon from '@mui/icons-material/Clear';
import Loader from '../Loader';
import KeyboardArrowRightSharpIcon from '@mui/icons-material/KeyboardArrowRightSharp';
import filter from '../../Assets/images/svg/dar_filter_grey.svg';
import CustomDateRangePicker from '../DateRangePicker/dateRangePicker';
import dayjs from 'dayjs';
import ButtonComponent from '../Button/button';

const DataGridComponent = ({
  dataRows,
  dataColumns,
  pageSize,
  isFilteredRows,
  sortFilterColumns = [], // Default to an empty array,
  isEdit,
  gridCheckbox = false,
  onRowSelectionChange,
  dataGridCss,
  checkboxDisabled,
  rowHeightCondition,
  setTablePageNumber,
  tablePageNumber,
  isBackendPaginated,
  totalPages,
  totalRecords,
  onSortChange,
  sortField,
  sortOrder,
  isDealTransition,
  hideSeparator = false,
  hideFooter = false,
  sortingMode,
  paginationMode= 'client',
  hideAutoheight,
  updateSortModel,
  excludeSuperAdmin = false,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [sortModel, setSortModel] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [searchText, setSearchText] = useState('');
  const [searchColumn, setSearchColumn] = useState('');
  const [filteredSortedData, setFilteredSortedData] = useState([]);
  const [paginatedData, setPaginatedData] = useState([]);
  const [checkClick, setCheckClick] = useState(false);
  const [cleared, setCleared] = useState(false);
  const [selectedRow, setSelectedRow] = useState([]);
  const [loading, setLoading] = useState(true);


  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [anchorNewEl, setAnchorNewEl] = useState(null);
  const [keepPopperOpen, setKeepPopperOpen] = useState(false); // State to keep popper open

  // Open the date picker popup
  const handleClickEvent = (event) => {
    setAnchorNewEl(event.currentTarget);
    setKeepPopperOpen(true); // Keep popper open
  };

  // Close the date picker popup
  const handleClose = () => {
    setAnchorNewEl(null);
    setKeepPopperOpen(false);
  };

  const handleDateRangeChange = ([start, end]) => {
    setStartDate(start);
    setEndDate(end);
  };

  const filterDataByDate = (dataRows, selectedStartDate, selectedEndDate, searchColumn) => {
    const startDate = selectedStartDate ? dayjs(selectedStartDate).format('YYYY-MM-DD') : null;
    const endDate = selectedEndDate ? dayjs(selectedEndDate).format('YYYY-MM-DD') : null;
    if (!startDate && !endDate) return dataRows;
    return dataRows.filter((row) => {
      const rowDate = dayjs(row[searchColumn]).format('YYYY-MM-DD');
      return rowDate === startDate || (rowDate >= startDate && rowDate <= endDate);
    });
  };

  useEffect(() => {
    if (isBackendPaginated && tablePageNumber) {
      setCurrentPage(tablePageNumber);
    } else {
      setCurrentPage(currentPage);
    }
  }, [searchText, sortModel, isFilteredRows, startDate, endDate]);

  useEffect(() => {
    setCurrentPage(Number(currentPage));
  }, [isEdit]);
  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      let filteredData = filterData(dataRows, searchText, searchColumn);
      filteredData = filterDataByDate(filteredData, startDate, endDate, searchColumn);
      const sortedData = sortData(filteredData, sortModel);
      setFilteredSortedData(sortedData);
      setLoading(false);
    };
    fetchData();
  }, [dataRows, searchText, sortModel, isFilteredRows, startDate, endDate]);

  useEffect(() => {
    let paginated = filteredSortedData.slice(
      (currentPage - 1) * pageSize,
      (currentPage - 1) * pageSize + pageSize
    );
    setPaginatedData(paginated);
  }, [currentPage, filteredSortedData, pageSize]);

  useEffect(() => {
    if (
      paginatedData.length < pageSize &&
      currentPage > 1 &&
      filteredSortedData.length < (currentPage - 1) * pageSize + 1 &&
      !isBackendPaginated
    ) {
      setCurrentPage(currentPage - 1);
    }
  }, [paginatedData, pageSize, currentPage, filteredSortedData.length, isBackendPaginated]);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
    if (tablePageNumber && isBackendPaginated) {
      setTablePageNumber(value);
    }
  };

  const getRowClassName = (params) => {
    return params.indexRelativeToCurrentPage % 2 === 0 ? 'odd-row' : 'even-row';
  };

  const filterData = (dataRows, searchText, searchColumn) => {
    return searchText.length >= 1
      ? dataRows.filter((row) => {
        const columnValue = row[searchColumn];
        if (typeof columnValue === 'number') {
          return columnValue.toString().includes(searchText);
        } else if (typeof columnValue === 'string') {
          return columnValue.toLowerCase().includes(searchText.toLowerCase());
        } else if (typeof columnValue === 'boolean') {
          return columnValue.toString().includes(searchText);
        }
        return false;
      })
      : dataRows;
  };


  const sortSlotTime = (a, b, order) => {
    const getMinutes = (timeStr) => {
      if (!timeStr) return 0;
      const match = timeStr.match(/(\d{1,2}):(\d{2})\s*(AM|PM)/i);
      if (!match) return 0;
      let [, hour, minute, period] = match;
      hour = parseInt(hour, 10);
      minute = parseInt(minute, 10);
      if (period.toUpperCase() === 'PM' && hour !== 12) hour += 12;
      if (period.toUpperCase() === 'AM' && hour === 12) hour = 0;
      return hour * 60 + minute;
    };

    const [aStart] = (a || '').split('-').map((s) => s.trim());
    const [bStart] = (b || '').split('-').map((s) => s.trim());

    const aStartMin = getMinutes(aStart);
    const bStartMin = getMinutes(bStart);

    return order === 'asc' ? aStartMin - bStartMin : bStartMin - aStartMin;
  };

  const sortData = (data, sortModel) => {
    if (sortModel.length === 0) return data;

    const { field: sortField, sort: sortOrder } = sortModel[0];

    // Separate total row and regular rows
    const totalRow = data.find(row => row?.id === 'Total');
    const regularRows = data.filter(row => row?.id !== 'Total');

    const sortBoolean = (a, b, order) => {
      if (order === 'asc') {
        return (a ? 1 : 0) - (b ? 1 : 0);
      } else {
        return (b ? 1 : 0) - (a ? 1 : 0);
      }
    };

    const sortNumeric = (a, b, order) => {
      if (order === 'asc') {
        return a - b;
      } else {
        return b - a;
      }
    };

    const sortString = (a, b, order) => {
      const aStr = a ? a.toString().toLowerCase() : '';
      const bStr = b ? b.toString().toLowerCase() : '';
      if (aStr < bStr) return order === 'asc' ? -1 : 1;
      if (aStr > bStr) return order === 'asc' ? 1 : -1;
      return 0;
    };

    const sortedRegularRows = regularRows.slice().sort((a, b) => {
      const aValue = a[sortField];
      const bValue = b[sortField];

      if (typeof aValue === 'boolean' && typeof bValue === 'boolean') {
        return sortBoolean(aValue, bValue, sortOrder);
      }

      if (typeof aValue === 'number' && typeof bValue === 'number') {
        return sortNumeric(aValue, bValue, sortOrder);
      }

    
      if (sortField === 'slot') {
        return sortSlotTime(aValue, bValue, sortOrder);
      }

      return sortString(aValue, bValue, sortOrder);
    });

    return totalRow ? [...sortedRegularRows, totalRow] : sortedRegularRows;
  };
  

  const handleSortModelChange = (model) => {
    if (isBackendPaginated) {
      if (onSortChange) {
        onSortChange(model);
      }
      return;
    }

    if (updateSortModel)  {
      updateSortModel(model);
    }
    setSortModel(model);
  };

  const handleMouseEnter = (field) => {
    (!searchText && !startDate && !endDate) && setSearchColumn(field);
  };
  const handleMouseLeave = () => {
    if (!searchText && !startDate && !endDate) {
      setAnchorEl(null);
      setAnchorNewEl(null);
      setSearchColumn('');
    }
  };
  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleSearch = (event, field) => {
    const value = event.target.value.toLowerCase();
    setSearchText(value);
  };

  const getSortingIcon = (field) => {

    if (isBackendPaginated) {
      if (sortField === field) {
        switch (sortOrder) {
          case 'asc':
            return <KeyboardArrowUpSharpIcon />;
          case 'desc':
            return <KeyboardArrowDownSharpIcon />;
          default:
            return <UnfoldMoreSharpIcon />;
        }
      } else {
        return <UnfoldMoreSharpIcon />;
      }
    }
    const sortItem = sortModel.find((item) => item.field === field) || {};
    let icon;

    switch (sortItem.sort) {
      case 'asc':
        icon = <KeyboardArrowUpSharpIcon />;
        break;
      case 'desc':
        icon = <KeyboardArrowDownSharpIcon />;
        break;
      default:
        icon = <UnfoldMoreSharpIcon />;
        break;
    }

    return icon;
  };

  // function getFilterIcon for text and date filters
  const getFilterIcon = (field) => {
    const column = dataColumns.find((col) => col.field === field);
    const handleClickAway = () => {
      if (searchText || startDate || endDate) {
        setCheckClick(true);
      }
      if (cleared && !searchText) {
        setSearchColumn('');
      }
      if (!keepPopperOpen) {
        setAnchorEl(null);
        setAnchorNewEl(null);
      }
    };
    const isFiltered = checkClick && searchText || (checkClick && startDate && endDate);

    return (
      field === searchColumn && (
        <>
          <IconButton
            onClick={handleClick}
            className="filter-alt-icon"
            aria-label="Filter options"
          >
            <img
              src={isFiltered ? FilterAltIcon : MoreIcon}
              alt="Filter icon"
              className="filter-alt-icon"
            />
          </IconButton>
          <ClickAwayListener onClickAway={handleClickAway}>
            <Popper
              open={Boolean(anchorEl)}
              anchorEl={anchorEl}
              placement="bottom-start"
            >
              <Paper className={`popper-paper ${!column.showTextFilter && column.showDateFilter ? 'date-filer' : ''}`}>
                {(column.showTextFilter ?? true) && (
                  <>
                    <div className="popper-text-filter-text">Text Filter</div>
                    <div className="popper-text-filter-img">
                      <img src={MagnifyingGlass} alt="Search" />
                      <input
                        id="datagrid-search-input"
                        type="text"
                        placeholder="Search..."
                        value={searchText}
                        onChange={(event) => handleSearch(event, field)}
                      />
                      {searchText && (
                        <IconButton
                          onClick={() => {
                            setSearchText('');
                            setCleared(true);
                            setAnchorEl(null);
                            setCheckClick(false);
                            setSearchColumn('');
                          }}
                          className="clear-search-icon"
                        >
                          <ClearIcon />
                        </IconButton>
                      )}
                    </div>
                  </>
                )}
                {(column.showDateFilter ?? false) && (
                  <div className="popper-date-filter-date">
                    <ButtonComponent
                      label="Filter"
                      variant="text"
                      onClick={handleClickEvent}
                      endIcon={<KeyboardArrowRightSharpIcon />}
                      startIcon={<img alt="filter" src={filter} />}
                      btnCss={`popper-filter-btn ${anchorNewEl ? 'popper-filter-btn-active' : ''}`}
                    ></ButtonComponent>
                  </div>
                )}
                <CustomDateRangePicker
                  anchorEl={anchorNewEl}
                  onClose={handleClose}
                  startDate={startDate}
                  endDate={endDate}
                  onChange={handleDateRangeChange}
                />
              </Paper>
            </Popper>
          </ClickAwayListener>
        </>
      )
    );
  };

  const determineNewSortModel = (columnField) => {
    const isBooleanColumn = dataRows.some(
      (row) => typeof row[columnField] === 'boolean'
    );

    if (isBooleanColumn) {
      if (sortModel[0]?.field === columnField) {
        if (sortModel[0]?.sort === 'desc') {
          return [{ field: columnField, sort: 'asc' }];
        } else if (sortModel[0]?.sort === 'asc') {
          return [];
        }
      }
      return [{ field: columnField, sort: 'desc' }];
    } else {
      if (sortModel[0]?.field === columnField) {
        if (sortModel[0]?.sort === 'asc') {
          return [{ field: columnField, sort: 'desc' }];
        } else if (sortModel[0]?.sort === 'desc') {
          return [];
        }
      }
      return [{ field: columnField, sort: 'asc' }];
    }
  };


  const enhancedColumns = dataColumns.map((column) => {
    const baseColumn = {
      ...column,
    };
  
    if (Array.isArray(sortFilterColumns) && sortFilterColumns.includes(column.field)) {
      return {
        ...baseColumn,
        renderHeader: (params) => {
          const { colDef } = params;
          const isSorted =
            sortModel.length > 0 && sortModel[0].field === colDef.field;
          return (
            <button
              className={`header-column-sort-filter ${
                isSorted || searchText || (startDate && endDate)
                  ? 'header-column-sorted'
                  : ''
              }`}
              onMouseEnter={() => handleMouseEnter(column.field)}
              onMouseLeave={handleMouseLeave}
            >
              {colDef.field === 'select' ? (
                colDef.headerName
              ) : (
                <Tooltip
                  title={params.colDef.headerName}
                  style={{
                    whiteSpace: params.colDef.multiLineHeader
                      ? 'pre-line'
                      : 'nowrap',
                    textAlign: 'left',
                  }}
                  arrow
                >
                  {params.colDef.headerName}
                </Tooltip>
              )}
              {colDef.field !== 'select' && (
                <>
                  <IconButton
                    onClick={() =>
                      handleSortModelChange(determineNewSortModel(column.field))
                    }
                  >
                    {getSortingIcon(column.field)}
                  </IconButton>
                  {!params.colDef.hideCoumnMenuIcon &&
                    getFilterIcon(column.field)}
                </>
              )}
            </button>
          );
        },
      };
    } else {
      return baseColumn;
    }
  });
  
  // ...existing code...
  if (gridCheckbox) {
    // Determine selectable rows across all pages (excluding Super Admin rows if flag enabled, and disabled grid)
    const targetDataset = isBackendPaginated ? dataRows : filteredSortedData;
    const selectableRows = targetDataset.filter(
      (row) => !checkboxDisabled && (!excludeSuperAdmin || row.roleName !== 'Super Admin')
    );
    const selectableIds = selectableRows.map((row) => row.id);
    const isAllSelected =
      selectableIds.length > 0 &&
      selectableIds.every((id) => selectedRow.includes(id));
    const isSomeSelected =
      selectableIds.some((id) => selectedRow.includes(id)) && !isAllSelected;

    const handleSelectAllChange = (event) => {
      let newSelection;
      if (event.target.checked) {
        // Add all selectable rows across all pages to selection
        const newIdsSet = new Set([...selectedRow, ...selectableIds]);
        newSelection = Array.from(newIdsSet);
      } else {
        // Deselect all selectable rows across all pages
        newSelection = selectedRow.filter((id) => !selectableIds.includes(id));
      }
      setSelectedRow(newSelection);
      if (onRowSelectionChange) {
        onRowSelectionChange(newSelection);
      }
    };

    // Add custom checkbox column
    const checkboxColumn = {
      field: 'checkbox',
      headerName: '',
      width: 70,
      disableColumnMenu: true,
      renderHeader: () => (
        <Checkbox
          checked={isAllSelected}
          indeterminate={isSomeSelected}
          disabled={selectableIds.length === 0 || checkboxDisabled}
          onChange={handleSelectAllChange}
          inputProps={{ 'aria-label': 'Select all rows' }}
        />
      ),
      renderCell: (params) => {
        const isSuperAdmin = excludeSuperAdmin && params.row.roleName === 'Super Admin';
        return (
          <Checkbox
            checked={selectedRow.includes(params.id)}
            disabled={checkboxDisabled || isSuperAdmin}
            onChange={() => handleCheckboxChange(params.id)}
            inputProps={{ 'aria-label': `Checkbox ${params.id}` }}
          />
        );
      },
    };

    // Insert checkbox column at the beginning of the columns array
    enhancedColumns.unshift(checkboxColumn);

    const handleCheckboxChange = (id) => {
      const newSelection = selectedRow.includes(id)
        ? selectedRow.filter((selectedId) => selectedId !== id)
        : [...selectedRow, id];
      setSelectedRow(newSelection);
      if (onRowSelectionChange) {
        onRowSelectionChange(newSelection);
      }
    };
  }

  const paginationButton = () => {
    if (isBackendPaginated) {
      return (
        <PaginationButtons
          currentPage={currentPage}
          pageSize={pageSize}
          totalPages={totalPages}
          totalRecords={totalRecords}
          paginatedData={paginatedData}
          filteredSortedData={filteredSortedData}
          handlePageChange={handlePageChange}
          isBackendPaginated={isBackendPaginated}

        />
      );
    } else {
      return (
        <PaginationButtons
          currentPage={currentPage}
          pageSize={pageSize}
          paginatedData={paginatedData}
          filteredSortedData={filteredSortedData}
          handlePageChange={handlePageChange}

        />
      );
    }
  };

  return (
    <div className={`data-grids ${dataGridCss}`}>
      {loading ? (
        <Loader />
      ) : (
        <div className={hideAutoheight ? 'hide-auto-height' : 'set-auto-height'}>
        <DataGrid
          autoHeight={!hideAutoheight}
          disableColumnSelector
          rows={isBackendPaginated ? dataRows : paginatedData} // Use your manually paginated data
          columns={enhancedColumns}
          disableRowSelectionOnClick
          getRowClassName={getRowClassName}
          getRowHeight={(params) => {
            return isDealTransition ? 'auto' : rowHeightCondition ? rowHeightCondition(params) : 52;
          }}
          hideFooter={hideFooter}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: pageSize },
            },
          }}
          paginationMode={paginationMode}
          slots={{
            pagination: paginationButton,
          }}
          disableDensitySelector
          sortModel={sortModel}
          sortingMode={sortingMode}  // set to 'server' to disable built-in sorting
          onSortModelChange={handleSortModelChange}
          localeText={{ noRowsLabel: 'No records found' }}
          columnBuffer={paginatedData.length}
          sx={
            hideSeparator === true
              ? {
                  '& .MuiDataGrid-columnSeparator': {
                    display: 'none',
                  },
                }
              : undefined
          }
        />
        </div>
      )}
    </div>
  );
};

DataGridComponent.propTypes = {
  dataRows: PropTypes.arrayOf(PropTypes.object).isRequired,
  dataColumns: PropTypes.arrayOf(PropTypes.object).isRequired,
  pageSize: PropTypes.number.isRequired,
  isFilteredRows: PropTypes.arrayOf(PropTypes.object).isRequired,
  sortFilterColumns: PropTypes.array.isRequired,
  isEdit: PropTypes.bool,
  gridCheckbox: PropTypes.bool,
  onRowSelectionChange: PropTypes.func,
  dataGridCss: PropTypes.any,
  checkboxDisabled: PropTypes.bool,
  isBackendPaginated: PropTypes.bool,
  setTablePageNumber: PropTypes.any,
  tablePageNumber: PropTypes.any,
  totalPages: PropTypes.any,
  totalRecords: PropTypes.any,
  rowHeightCondition: PropTypes.any,
  onSortChange: PropTypes.func,
  sortField: PropTypes.string,
  sortOrder: PropTypes.string,
  hideSeparator: PropTypes.bool,
  isDealTransition: PropTypes.bool,
  hideFooter: PropTypes.bool,
  sortingMode: PropTypes.string,
  paginationMode: PropTypes.string,
  hideAutoheight: PropTypes.bool,
  checkboxHeaderLabel: PropTypes.string,
  updateSortModel: PropTypes.func,
  excludeSuperAdmin: PropTypes.bool,
};

export default DataGridComponent;